/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from '@/axios.js'

// import state from './moduleUserManagementState.js'
// import mutations from './moduleUserManagementMutations.js'
// import actions from './moduleUserManagementActions.js'
// import getters from './moduleUserManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state:{
    users: [],
    loans: [],
  },
  mutations:{
    SET_USERS (state, users) {
      state.users = users
    },
    SET_LOANS (state, data) {
      state.loans = data
    },
    ADD_RECORD (state, item) {
      state.users.push({
        uuid: item.uuid,
        name: item.name,
        role: item.role,
        group_code: item.group_code,
        company_code: item.company_code,
        primary_contact: item.primary_contact,
        secondary_contact: item.secondary_contact,
        email: item.email,
        remark: item.remark,
        status: item.status,
        groupid: item.groupid
      })
    },
    UPDATE_RECORD (state, item) {
      const userIndex = state.users.findIndex((u) => u.uuid === item.uuid)
      state.users[userIndex].name = item.name
      state.users[userIndex].role = item.role
      state.users[userIndex].group_code = item.group_code
      state.users[userIndex].company_code = item.company_code
      state.users[userIndex].primary_contact = item.primary_contact
      state.users[userIndex].secondary_contact = item.secondary_contact
      state.users[userIndex].email = item.email
      state.users[userIndex].remark = item.remark
      state.users[userIndex].status = item.status
      state.users[userIndex].groupid = item.groupid
      state.users[userIndex].permissions = item.permissions
    },
    UPDATE_STATUS (state, item) {
      const userIndex = state.users.findIndex((u) => u.uuid === item.uuid)
      let current_status = state.users[userIndex].status
      state.users[userIndex].status = current_status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
    },
    REMOVE_RECORD (state, itemId) {
      const userIndex = state.users.findIndex((u) => u.uuid === itemId)
      state.users.splice(userIndex, 1)
    }
  },
  actions:{
      fetchLoans ({ commit }) {
        return new Promise((resolve, reject) => {
          let formData = new FormData();
          formData.append('status', 'ACTIVE,COMPLETE');
          axios.post('/loans/list',formData)
            .then((response) => {
              commit('SET_LOANS', response.data.data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
        })
      },
      fetchUsers ({ commit }) {
        return new Promise((resolve, reject) => {
          axios.post('/users/list')
            .then((response) => {
              commit('SET_USERS', response.data.data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
        })
      },
      addRecord ({ commit }, data) {
        return new Promise((resolve, reject) => {
          axios.post(`/users`,data.form_data)
            .then((response) => {
              console.log('addRecord response',response)
              data.uuid = response.data.data.id
              commit('ADD_RECORD', data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
        })
      },
      updateRecord ({ commit }, data) {
        return new Promise((resolve, reject) => {
          axios.post(`/users/${data.uuid}`,data.form_data)
            .then((response) => {
              console.log('updateRecord response',response)
              commit('UPDATE_RECORD', data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
        })
      },
      updateStatus ({ commit }, data) {
        return new Promise((resolve, reject) => {
          axios.post(`/users/${data.uuid}`,data.form_data)
            .then((response) => {
              commit('UPDATE_STATUS', data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
        })
      }
  },
  getters:{

  }
}

